import { Avatar, Card } from "react-native-paper";
import { UserContext } from "../data/userContext";
import { initials } from "../common/util";
import LogOutButton from "./LogOutButton";
import React from "react";

export default function UserPreferences() {
  const { user, authUser } = React.useContext(UserContext);
  if (!user) return null;
  const displayName = user.get("displayName") ?? authUser.displayName;
  return (
    <Card style={{ margin: 2 }}>
      <Card.Title
        title={displayName}
        subtitle={user.get("email") ?? authUser.email}
        left={(props) => (
          <Avatar.Text {...props} label={initials(displayName) ?? ""} />
        )}
      />
      <Card.Actions>
        <LogOutButton />
      </Card.Actions>
    </Card>
  );
}
